export interface ICommand { }

export class AbortRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.AbortRunCommandV1, TCh.Domain.Integrations'

	Id: string
	AbortReason: string

	constructor (id: string, abortReason: string)
	{
		this.Id = id
		this.AbortReason = abortReason
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.AbortRunCommandV1, TCh.Domain.Integrations'
	}

}

export class AppendRunLogCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.AppendRunLogCommandV1, TCh.Domain.Integrations'

	Id: string
	OccuredAt: any
	OrganizationUnitId: string
	Message: string

	constructor (id: string, occuredAt: any, organizationUnitId: string, message: string)
	{
		this.Id = id
		this.OccuredAt = occuredAt
		this.OrganizationUnitId = organizationUnitId
		this.Message = message
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.AppendRunLogCommandV1, TCh.Domain.Integrations'
	}

}

export class CompleteRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.CompleteRunCommandV1, TCh.Domain.Integrations'

	Id: string
	QueuedBy: string | null
	QueuedAt: any

	constructor (id: string, queuedBy: string | null, queuedAt: any)
	{
		this.Id = id
		this.QueuedBy = queuedBy
		this.QueuedAt = queuedAt
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.CompleteRunCommandV1, TCh.Domain.Integrations'
	}

}

export class DeleteRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.DeleteRunCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	DeletedBy: string

	constructor (id: string, organizationUnitId: string, deletedBy: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.DeletedBy = deletedBy
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.DeleteRunCommandV1, TCh.Domain.Integrations'
	}

}

export class FailRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.FailRunCommandV1, TCh.Domain.Integrations'

	Id: string
	FailureReason: string

	constructor (id: string, failureReason: string)
	{
		this.Id = id
		this.FailureReason = failureReason
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.FailRunCommandV1, TCh.Domain.Integrations'
	}

}

export class PermanentDeleteRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.PermanentDeleteRunCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.PermanentDeleteRunCommandV1, TCh.Domain.Integrations'
	}

}

export class QueueRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.QueueRunCommandV1, TCh.Domain.Integrations'

	Id: string
	OrganizationUnitId: string
	PipelineId: string
	QueuedBy: string | null
	Trigger: string
	TriggerData: string

	constructor (id: string, organizationUnitId: string, pipelineId: string, queuedBy: string | null, trigger: string, triggerData: string)
	{
		this.Id = id
		this.OrganizationUnitId = organizationUnitId
		this.PipelineId = pipelineId
		this.QueuedBy = queuedBy
		this.Trigger = trigger
		this.TriggerData = triggerData
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.QueueRunCommandV1, TCh.Domain.Integrations'
	}

}

export class StartRunCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Integrations.Runs.Commands.StartRunCommandV1, TCh.Domain.Integrations'

	Id: string

	constructor (id: string)
	{
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Integrations.Runs.Commands.StartRunCommandV1, TCh.Domain.Integrations'
	}

}

